import * as React from "react";

import DropdownInput from "./DropdownInput";

const PROVINCES_PICKLISTTYPEID = 4;

interface IProvinceOption {
	text: string;
	value: string;
}
const defaultProvinceOptions: IProvinceOption[] = [
	{
		text: "",
		value: "",
	},
];

interface IProps {
	// passed props
	province: string;
	onChange: (e: any) => void;
	labelText?: string;
	name?: string;
	className?: string;
	required?: boolean;

	// own props
	provinces: PickListItem[];
}

class ProvinceDropdown extends React.Component<IProps> {
	private provinceOptions = defaultProvinceOptions;
	constructor(props: IProps) {
		super(props);
		this.provinceOptions = this.props.provinces.map((p: PickListItem) => {
			return { text: p.description!, value: p.description! };
		});
	}

	public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
		this.provinceOptions = nextProps.provinces.map((p: PickListItem) => {
			return { text: p.description!, value: p.description! };
		});
	}

	public render() {
		return (
			<DropdownInput
				labelText={this.props.labelText}
				name={this.props.name || "province"}
				defaultOption="-"
				options={this.provinceOptions}
				onChange={this.props.onChange}
				value={this.props.province || ""}
				className={this.props.className}
				required={this.props.required}
			/>
		);
	}
}

export default ProvinceDropdown;
